export enum LocalStorageSubKey {
  ChatOpen = 'CHAT_OPEN',
  VerifiedFields = 'VERIFIED_FIELDS',
  Token = 'TOKEN',
  Initials = 'INITIALS',
  RecipientId = 'RECIPIENT_ID',
}
